import React, {useEffect, useState} from 'react'
import _ from "lodash";
import {searchQuotes, searchQuotesWithSearchCriteria} from "../../../common/services/quote-data-service";
import {searchDesigns} from "../../services/design-data-service";
import {searchParentProducts} from "../../../pod/services/parent-product-data-service";
import SelectTags from "../../../tag/select-tags";

const DesignDetails = ({
                           isEditDesign,
                           designDetail,
                           setDesignDetail,
                           podList,
                           themeList,
                           selectedPod,
                           setSelectedPod,
                           allTags
                       }) => {
    const [selectedProductType, setSelectedProductType] = useState(null);
    const [selectedCategory, setSelectedCategory] = useState(null);
    const [selectedParentProduct, setSelectedParentProduct] = useState(null);
    const [parentProduct, setParentProduct] = useState(null);
    const [selectedQuote, setSelectedQuote] = useState(null);
    const [selectedTheme, setSelectedTheme] = useState(null);
    const [selectedSize, setSelectedSize] = useState(null);
    const [quoteList, setQuoteList] = useState(null);

    useEffect(() => {
        if (isEditDesign) {
            prepareDesignDetailFields();
        }
    }, [isEditDesign]);

    useEffect(() => {
        if (selectedTheme) {
            getAllQuoteList();
        }
    }, [selectedTheme]);

    const getAllQuoteList = async () => {
        const quoteListResult = await searchQuotesWithSearchCriteria(prepareSearchCriteria());
        setQuoteList(_.orderBy(quoteListResult, ['startText']));
        prepareDesignDetailFieldsQuote(quoteListResult);
    }

    const prepareSearchCriteria = () => {
        const searchCriteriaList = [];

        if (!_.isEmpty(selectedTheme)) {
            searchCriteriaList.push({field: 'themes.' + selectedTheme?.id, condition: '==', value: true});
        }

        return searchCriteriaList;
    }

    const prepareDesignDetailFieldsQuote = (existingQuoteList) => {
        const existingDesignDetail = {...designDetail};
        const quoteMap = _.keyBy(existingQuoteList, 'id');
        const tempQuote = quoteMap[existingDesignDetail.quoteId];

        setSelectedQuote(tempQuote);
    }

    const prepareDesignDetailFields = () => {
        const existingDesignDetail = {...designDetail};

        const podsMap = _.keyBy(podList, 'id');
        const tempPod = podsMap[existingDesignDetail.podId];

        const productTypesMap = _.keyBy(tempPod.productTypesList, 'name');
        const tempProductType = productTypesMap[existingDesignDetail.productType];

        const categoriesMap = _.keyBy(tempProductType.categories, 'name');
        const tempCategory = categoriesMap[existingDesignDetail.category];

        const parentProductsMap = _.keyBy(tempCategory.parentProducts, 'name');
        const tempParentProduct = parentProductsMap[existingDesignDetail.parent];

        const sizesMap = _.keyBy(tempParentProduct.sizes, 'name');
        const tempSize = sizesMap[existingDesignDetail.size];

        const themeMap = _.keyBy(themeList, 'id');
        const tempTheme = themeMap[existingDesignDetail.themeId];

        setSelectedPod(tempPod);
        setSelectedProductType(tempProductType);
        setSelectedCategory(tempCategory);
        setSelectedParentProduct(tempParentProduct);
        setSelectedSize(tempSize);
        setSelectedTheme(tempTheme);
    }

    const handleDetailChanges = (event) => {
        const {name, value} = event.target;
        const existingDesignDetail = {...designDetail};
        existingDesignDetail[name] = value;

        let currentParentProduct = {...selectedParentProduct};
        let currentQuote = {...selectedQuote};
        let currentTheme = {...selectedTheme};
        let currentSize = {...selectedSize};

        if (name === 'podId') {
            const podsMap = _.keyBy(podList, 'id');
            const tempPod = podsMap[value];
            setSelectedPod(tempPod);
            setSelectedProductType(null);

            existingDesignDetail.market = tempPod.market;
            existingDesignDetail.podName = tempPod.name;
        } else if (name === 'productType') {
            const productTypesMap = _.keyBy(selectedPod.productTypesList, 'name');
            const tempProductType = productTypesMap[value];
            setSelectedProductType(tempProductType);
            setSelectedCategory(null);
        } else if (name === 'category') {
            const categoriesMap = _.keyBy(selectedProductType.categories, 'name');
            const tempCategory = categoriesMap[value];
            setSelectedCategory(tempCategory);
            setSelectedParentProduct(null);
        } else if (name === 'parent') {
            const parentProductsMap = _.keyBy(selectedCategory.parentProducts, 'name');
            currentParentProduct = parentProductsMap[value];
            setSelectedParentProduct(currentParentProduct);
        } else if (name === 'size') {
            const sizesMap = _.keyBy(selectedParentProduct.sizes, 'name');
            currentSize = sizesMap[value];
            setSelectedSize(currentSize);
        } else if (name === 'quoteId') {
            const quotesMap = _.keyBy(quoteList, 'id');
            currentQuote = quotesMap[value];
            setSelectedQuote(currentQuote);

            existingDesignDetail.quoteName = currentQuote.startText;
        } else if (name === 'themeId') {
            const themeMap = _.keyBy(themeList, 'id');
            currentTheme = themeMap[value];
            setSelectedTheme(currentTheme);

            existingDesignDetail.themeName = currentTheme.startText;
        } else if (name === 'tagList') {
            const tempTags = {};
            _.forEach(value, tagId => {
                tempTags[tagId] = true;
            });

            existingDesignDetail['tags'] = tempTags;
            existingDesignDetail['tagList'] = value;
        }

        existingDesignDetail.name = prepareName(currentParentProduct, currentQuote, currentTheme, currentSize);
        setDesignDetail(existingDesignDetail);

        if (name === 'parent') {
            getSingleParentProductByDesignDetail(currentParentProduct);
        } else if (name === 'podId' || name === 'productType' || name === 'category') {
            setParentProduct(null);
        }
    }

    const getSingleParentProductByDesignDetail = async (currentParentProduct) => {
        const existingDesignDetail = {...designDetail};

        const searchCriteriaList = [];
        searchCriteriaList.push({field: 'podId', condition: '==', value: existingDesignDetail?.podId});
        searchCriteriaList.push({field: 'market', condition: '==', value: existingDesignDetail?.market});
        searchCriteriaList.push({field: 'productType', condition: '==', value: existingDesignDetail?.productType});
        searchCriteriaList.push({field: 'category', condition: '==', value: existingDesignDetail?.category});
        searchCriteriaList.push({field: 'name', condition: '==', value: currentParentProduct?.name});

        searchParentProducts(searchCriteriaList)
            .then(async parentProductsList => {
                setParentProduct(parentProductsList[0]);
            });
    }

    const prepareName = (currentParentProduct, currentQuote, currentTheme, currentSize) => {
        let designNameList = [];

        console.log({currentQuote});

        if (!_.isEmpty(currentQuote)) {
            designNameList.push(currentQuote.startText);
        }

        if (!_.isEmpty(currentTheme)) {
            designNameList.push(currentTheme.startText);
        }

        if (!selectedPod.ignoreProductTypeInDesignName) {
            if (!_.isEmpty(currentParentProduct)) {
                designNameList.push(currentParentProduct.name);
            }

            if (!_.isEmpty(currentSize)) {
                designNameList.push(currentSize.name);
            }
        }

        return _.join(designNameList, ' | ');
    }

    return (
        <>
            <div className="">

                <div className="flex justify-start">
                    <div className="field-group-container">

                        <div className="field-container">
                            <div className="field-label">
                                POD
                            </div>
                            <select
                                className="input-field"
                                id="podId"
                                name="podId"
                                value={designDetail?.podId}
                                onChange={handleDetailChanges}>
                                <option value="">Choose POD</option>
                                {podList?.map((pod, index) => (
                                    <option key={index}
                                            value={pod?.id}>{pod?.displayLabel}</option>
                                ))}
                            </select>
                        </div>

                        {selectedPod &&
                            <div className="field-container">
                                <div className="field-label">
                                    Product Type <span
                                    className="pl-1 text-gray-400">({selectedPod?.productTypesList?.length})</span>
                                </div>
                                <select
                                    className="input-field"
                                    id="productType"
                                    name="productType"
                                    value={designDetail?.productType}
                                    onChange={handleDetailChanges}>
                                    <option value="">All Product Types</option>
                                    {selectedPod?.productTypesList?.map((option, index) => (
                                        <option key={index}
                                                value={option?.name}>{option?.name}</option>
                                    ))}
                                </select>
                            </div>
                        }

                        {selectedProductType &&
                            <div className="field-container">
                                <div className="field-label">
                                    Category
                                    {selectedProductType &&
                                        <span
                                            className="pl-1 text-gray-400">({selectedProductType?.categories?.length})</span>
                                    }
                                </div>
                                <select
                                    className="input-field"
                                    id="category"
                                    name="category"
                                    value={designDetail?.category}
                                    onChange={handleDetailChanges}>
                                    <option value="">Choose Category</option>
                                    {selectedProductType?.categories?.map((option, index) => (
                                        <option key={index}
                                                value={option?.name}>{option?.name}</option>
                                    ))}
                                </select>
                            </div>
                        }

                        {selectedCategory &&
                            <div className="field-container">
                                <div className="field-label">
                                    Parent Product
                                    {selectedCategory &&
                                        <span
                                            className="pl-1 text-gray-400">({selectedCategory?.parentProducts?.length})</span>
                                    }
                                </div>
                                <select
                                    className="input-field"
                                    id="parent"
                                    name="parent"
                                    value={designDetail?.parent}
                                    onChange={handleDetailChanges}>
                                    <option value="">Choose Parent Product</option>
                                    {selectedCategory?.parentProducts?.map((option, index) => (
                                        <option key={index}
                                                value={option?.name}>{option?.name}</option>
                                    ))}
                                </select>
                            </div>
                        }

                        {selectedParentProduct && parentProduct?.isMultiMeasurement &&
                            <div className="field-container">
                                <div className="field-label">
                                    Product Size
                                </div>
                                <select
                                    className="input-field"
                                    id="size"
                                    name="size"
                                    value={designDetail?.size}
                                    onChange={handleDetailChanges}>
                                    <option value="">Choose Size</option>
                                    {selectedParentProduct?.sizes?.map((size, index) => (
                                        <option key={index}
                                                value={size?.name}>{size?.name}</option>
                                    ))}
                                </select>
                            </div>
                        }

                    </div>
                </div>

                <div className="flex justify-start">
                    <div className="field-group-container">

                        <div className="field-container">
                            <div className="field-label">
                                Theme
                            </div>
                            <select
                                className="input-field"
                                id="themeId"
                                name="themeId"
                                value={designDetail?.themeId}
                                onChange={handleDetailChanges}>
                                <option value="">Choose Theme</option>
                                {themeList?.map((theme, index) => (
                                    <option key={index}
                                            value={theme?.id}>{theme?.startText}</option>
                                ))}
                            </select>
                        </div>

                        <div className="field-container">
                            <div className="field-label">
                                Quote
                            </div>
                            <select
                                className="input-field"
                                id="quoteId"
                                name="quoteId"
                                value={designDetail?.quoteId}
                                onChange={handleDetailChanges}>
                                <option value="">Choose Quote</option>
                                {quoteList?.map((quote, index) => (
                                    <option key={index}
                                            value={quote?.id}>{quote?.startText}</option>
                                ))}
                            </select>
                        </div>

                    </div>

                </div>

                <div>
                    {allTags &&
                        <div
                            className="h-80 overflow-y-scroll border-gray-400 border bg-blue-50 mb-4 rounded mx-2 mt-2 shadow-xl">
                            <SelectTags
                                existingTags={designDetail?.tagList || []}
                                allTags={allTags}
                                handleSelectTagsChanges={handleDetailChanges}
                                showAddTag="true"
                                showClearSelectedTags={false}
                                showClearSelectedTagsIcon={false}/>
                        </div>
                    }
                </div>

            </div>
        </>
    )
}

export default DesignDetails
